import { useDeferredValue, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

import { useWorklogHistory } from "../../../reactQuery/boards";
import { addAllBoard, setWorkHours } from "../../../redux/SearchSlice";
import { setAllGroupUser } from "../../../redux/TaskGroupingSlice";
import {
  getFlattenedGroupingUsers,
  getTotalWorklogHours,
  parseBoardIdsParam,
  parseUserIdsParam,
} from "../utils/myTaskUtils";
import { matchesWorklogSearch } from "../utils/worklogUtils";
import { useResponsive } from "../../../hooks/useResponsive";
import { getResponseData } from "../../../reactQuery/response";

export function useWorklogHistoryState() {
  const [currentTab, setCurrentTab] = useState("users");
  const dispatch = useDispatch();
  const isMobile = useResponsive("down", "md");
  const groupingUser = useSelector(
    (state) => state.groupingUser.allocationUsers
  );
  const boardList = useSelector((state) => state.search.boardSearch);
  const [searchParams] = useSearchParams();
  const userParam = searchParams.get("uid");
  const boardParam = searchParams.get("board");
  const dateRange = useSelector((state) => state.search.dateRange);
  const epicSearch = useSelector((state) => state.search.epicSearch);
  const searchText = useSelector((state) => state.search.searchText);
  const deferredSearchText = useDeferredValue(searchText);

  const user = useMemo(
    () =>
      isMobile ? parseUserIdsParam(userParam) : getFlattenedGroupingUsers(groupingUser),
    [groupingUser, isMobile, userParam]
  );

  const checkedList = useMemo(
    () => (isMobile ? parseBoardIdsParam(boardParam) : boardList),
    [boardList, boardParam, isMobile]
  );

  const { worklogHistory, isLoading } = useWorklogHistory({
    user,
    boardIds: checkedList,
    dateRange,
    epicSearch,
  });

  const totalWorklogs = useMemo(
    () => getResponseData(worklogHistory, []),
    [worklogHistory]
  );

  const filteredWorklogs = useMemo(
    () =>
      totalWorklogs.filter((worklog) =>
        matchesWorklogSearch(worklog, deferredSearchText)
      ),
    [deferredSearchText, totalWorklogs]
  );

  useEffect(() => {
    dispatch(setWorkHours(getTotalWorklogHours(filteredWorklogs)));
  }, [dispatch, filteredWorklogs]);

  useEffect(() => {
    return () => {
      dispatch(addAllBoard([]));
      dispatch(setAllGroupUser([]));
    };
  }, [dispatch]);

  return {
    currentTab,
    loading: isLoading,
    setCurrentTab,
    totalWorklogs,
    worklogs: filteredWorklogs,
  };
}
